import { styled } from '@mui/material/styles';
import React from 'react';

const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

interface IProps {
  children: React.ReactNode;
  spacingX?: number;
  spacingY?: number;
  className?: string;
}

const Padding = ({ children, className, spacingX = 2, spacingY = 1 }: IProps) => {
  return (
    <Root
      className={className}
      sx={{
        paddingX: spacingX,
        paddingY: spacingY,
      }}
    >
      {children}
    </Root>
  );
};

export default Padding;
